import React, { useState } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import API_URLS from './apiConfig';

const SearchResults = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const defaultlang = API_URLS.defaultLang;
  const homeUrl=API_URLS.baseFrontUrl;
  const textfield = defaultlang==='lang_br'?'Procurar':defaultlang==='lang_es'?'Buscar':'Search';
  const resultfor = defaultlang==='lang_br'?'Resultados para':defaultlang==='lang_es'?'Resultados para':'Results for';

  const sanitizeContent = (content) => {
    if (!content) return "";
    // Remove <button> tags within <p> tags
    return content.replace(/<p[^>]*>.*?<button[^>]*>.*?<\/button>.*?<\/p>/g, (match) => {
      return match.replace(/<button[^>]*>.*?<\/button>/g, "");
    });
  };

  const handleSearch = async () => {
    if (!query.trim()) {
      setError("Please enter a search term.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(API_URLS.getSearchData+`/${encodeURIComponent(
        query)}/${defaultlang}`
      );

      // Extract data from all relevant sections
      const { what_we_do_posts = [], who_we_are_posts = [], pages = [], menus = [] } = response.data;

      // Combine data into a single array with a section identifier
      const combinedResults = [
        ...what_we_do_posts.map((item) => ({
          id: item.id,
          title: Array.isArray(item.matched_data)?item.matched_data.title:Array.isArray(item.repeater_data)?item.repeater_data.title:'',
          description: sanitizeContent(item.matched_data.content),
          link: item.route.trim(),
          section: "What We Do",
        })),
        ...who_we_are_posts.map((item) => ({
          id: item.id,
          title: Array.isArray(item.matched_data)?item.matched_data.title:Array.isArray(item.repeater_data)?item.repeater_data.title:'',
          description: sanitizeContent(item.matched_data.content),
          link: item.route.trim(),
          section: "Who We Are",
        })),
        ...pages.map((item) => ({
          id: item.id,
          title: item.name,
          description: '',
          link: item.metadata_route.trim(),
          section: "Pages",
        })),
        ...menus.map((item) => ({
          id: '',
          title: item.title,
          description: '',
          link: item.link.trim(),
          section: "Pages",
        })),
      ];

      console.log(combinedResults);

      if (combinedResults.length === 0) {
        setError("No results found.");
      } else {
        setResults(combinedResults);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch search results. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavbarComponent />
      <div className="container search-result-page">
        {/* Search Bar */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "50px" }}>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            placeholder={textfield+"..."}
            style={{
              width: "300px",
              padding: "10px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px 0 0 4px",
              outline: "none",
            }}
          />
          <button
            onClick={handleSearch}
            style={{
              padding: "10px 20px",
              fontSize: "14px",
              backgroundColor: "#ff6f20",
              color: "#fff",
              border: "none",
              borderRadius: "0 4px 4px 0",
              cursor: "pointer",
              textTransform: "uppercase",
            }}
          >
            {textfield}
          </button>
        </div>

        {/* Results Section */}
        <h2>{resultfor} "{query}"</h2>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div style={{ borderTop: "1px solid #ccc" }}>
          {results.map((result, index) => (
            <>
              {
                result.title!=='' || result.description!=='' ?
                  <div
                  key={index}
                  style={{
                    padding: "15px 0",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  {/* <h3 style={{ color: "#333", marginBottom: "10px" }}>{result.section}</h3> */}
                  <a
                    href={homeUrl+result.link}
                    style={{
                      color: "#ff6f20",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {result.title}
                  </a>
                  {/* <p
                    style={{
                      margin: "10px 0",
                      fontSize: "14px",
                      color: "#333",
                    }}
                    dangerouslySetInnerHTML={{ __html: result.description }}
                  /> */}
                  <p
                    style={{
                      margin: "10px 0",
                      fontSize: "14px",
                      color: "#333",
                    }}
                  >
                    <a
                      href={homeUrl+result.link}
                    >
                      <span
                      dangerouslySetInnerHTML={{ __html: result.description }}
                    />
                    </a>
                  </p>
    
                </div>
                : null
              }
            </>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SearchResults;
